export const RUNNING = Symbol('running');
export const SUCCESS = true;
export const FAILURE = false;
